import { render, staticRenderFns } from "./coupon-detail.vue?vue&type=template&id=13f97e4b&scoped=true"
import script from "./coupon-detail.vue?vue&type=script&lang=js"
export * from "./coupon-detail.vue?vue&type=script&lang=js"
import style0 from "./coupon-detail.vue?vue&type=style&index=0&id=13f97e4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f97e4b",
  null
  
)

export default component.exports